import React from 'react';
import PlyrComponent from '../global/PlyrComponent';

import style from './TimelineVideo.module.scss';
import Observer from 'react-intersection-observer';

const TimelineVideo = props => {
  const plyrOptions = {
    controls: [
      'play-large',
      'play',
      'progress',
      'current-time',
      'mute',
      'volume',
      'captions',
      'settings',
      'fullscreen',
    ],
  };

  const hasVideo = () => {
    return props.video_file.url || props.youtube_id || props.vimeo_id;
  };

  return (
    hasVideo() && (
      <Observer
        className={`timeline-video ${style.videoWrapper}`}
        triggerOnce={true}
      >
        {inview => (
          <div className={`${style.wrap} ${inview ? style.fadeInUp : ''}`}>
            {hasVideo() && (
              <PlyrComponent options={plyrOptions} videoData={props} />
            )}
            {props.title && (
              <div className={style.videoTitle}>
                <h4>{props.title}</h4>
              </div>
            )}
            {props.body && (
              <p
                className={style.slideshowBody}
                dangerouslySetInnerHTML={{ __html: props.body }}
              />
            )}
          </div>
        )}
      </Observer>
    )
  );
};

export default TimelineVideo;



// WEBPACK FOOTER //
// ./src/components/timeline/TimelineVideo.js